import axios from 'axios';

export const submitQuickProfile = async (payload = {}) => {
    const endpoint = '/api/user/profile';

    try {
        const response = await axios.patch(endpoint, payload);
        const { data } = response;
        if (data.meta.success) return { ok: true, errors: null };
    } catch (error) {
        return { ok: false, errors: error };
    }
    return { ok: false };
};
